export default defineNuxtPlugin(() => {
    const $segment = {
        track(event: string, data: any) {
            // TODO: Implement
            console.log("Track", event, data);
        },
    };

    return {
        provide: {
            track: (event: string, data: any) => {
                $segment.track(event, data);
            },
        },
    };
});
